import { TYPES } from "./default_computer.type";

const initState = {
  defaultComputerAll: null,
  defaultComputerSelected: null,
  defaultComputerOpenAdd: false,
};

const defaultComputerReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_COMPUTER_ALL:
      return {
        ...state,
        defaultComputerAll: payload,
      };

    case TYPES.SET_DEFAULT_COMPUTER_SELECTED:
      return {
        ...state,
        defaultComputerSelected: payload,
      };

    case TYPES.SET_DEFAULT_COMPUTER_OPEN_ADD:
      return {
        ...state,
        defaultComputerOpenAdd: payload,
      };

    default:
      return state;
  }
};

export default defaultComputerReducer;
